// import React, { useState } from "react";
import { Form, Link, useActionData, useNavigation } from "react-router-dom";
import ButtonLoadingOnBusy from "../Library/LoadingButton";
import { useValidationErrors } from "../../utils/useValidationErrors";

const Errors: React.FC<{ errors: string[] | string }> = ({ errors }) => {
  if (typeof errors === "string") {
    errors = errors.split("\n");
  }
  return errors.length > 0 ? (
    <ul className="text-error list-disc list-outside ml-4">
      {errors.map((error) => (
        <li>
          <label className="label py-1">
            <span className="label-text-alt text-error">{error}</span>
          </label>
        </li>
      ))}
    </ul>
  ) : null;
};
const RegistrationPage: React.FC = () => {
  const errors = useValidationErrors();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const response = useActionData() as any; // if successful submit
  const navigation = useNavigation();
  const busy = navigation.state === "submitting";

  return (
    <Form method="post" action="/auth/register">
      <div className="hero min-h-screen bg-base-200">
        <div className="hero-content flex-col lg:flex-row-reverse">
          <div className="text-center lg:text-left">
            <h1 className="text-5xl font-bold">My Gut Guide Registration</h1>
            <p className="py-6">
              Create cutting-edge medical algorithms with our intuitive
              interface. Work seamlessly with colleagues to advance healthcare
              technology. Comply with industry regulations and standards
              effortlessly.
            </p>
          </div>
          <div className="card shrink-0 w-full max-w-md shadow-2xl bg-base-100">
            <div className="card-body">
              {response?.status === 201 ? (
                <>
                  <h2 className="card-title">Thanks for signing up!</h2>
                  <p>
                    Please check your email for a verification link. Make sure
                    to check your spam inbox.
                  </p>
                  <div className="card-actions justify-end">
                    <Link to={"/auth/login"} className="link link-primary">
                      Back
                    </Link>
                  </div>
                </>
              ) : (
                <>
                  {/* Full name */}
                  <label className="form-control">
                    <div className="label">
                      <span className="label-text">Full name</span>
                    </div>
                    <input
                      name="name"
                      required
                      type="text"
                      autoComplete="name"
                      className="input input-bordered"
                    />
                    <Errors errors={errors?.name || []} />
                  </label>
                  {/* Email */}
                  <label className="form-control">
                    <div className="label">
                      <span className="label-text">Email</span>
                    </div>
                    <input
                      name="email"
                      required
                      type="email"
                      autoComplete="email"
                      className="input input-bordered"
                      // className="input input-bordered invalid:border-error"
                    />
                    {/* <ul className="text-error list-disc list-outside ml-4">
                  <li>
                    <label className="label">
                      <span className="label-text-alt text-error">
                        Must be at least 14 characters long
                      </span>
                    </label>
                  </li>
                  <li>
                    <label className="label">
                      <span className="label-text-alt text-error">
                        Must be at least 14 characters long
                      </span>
                    </label>
                  </li>
                  <li>
                    <label className="label">
                      <span className="label-text-alt text-error">
                        Must be at least 14 characters long
                      </span>
                    </label>
                  </li>
                </ul> */}
                  </label>
                  {/* Password */}
                  <label className="form-control">
                    <div className="label">
                      <span className="label-text">Choose a password</span>
                    </div>
                    <input
                      name="password"
                      required
                      type="password"
                      className="input input-bordered"
                    />
                    <div className="label">
                      <span className="label-text-alt">
                        Must be at least 14 characters long
                      </span>
                    </div>
                    <Errors errors={errors?.password || []} />
                  </label>
                  {/* Company Name */}
                  <label className="form-control -mt-2">
                    <div className="label">
                      <span className="label-text">Company Name</span>
                    </div>
                    <input
                      name="company"
                      required
                      type="text"
                      autoComplete="organization"
                      className="input input-bordered"
                    />
                  </label>
                  {/* Phone Number */}
                  <label className="form-control">
                    <div className="label">
                      <span className="label-text">Phone Number</span>
                    </div>
                    <input
                      name="phoneNumber"
                      required
                      type="text"
                      autoComplete="tel"
                      className="input input-bordered"
                    />
                    <Errors errors={errors?.phoneNumber || []} />
                  </label>

                  <label className="label cursor-pointer justify-normal gap-4">
                    <input type="checkbox" required className="checkbox" />
                    <span className="label-text">
                      Agree to terms and conditions
                    </span>
                  </label>

                  <div className="form-control mt-6">
                    <ButtonLoadingOnBusy
                      type="submit"
                      className="btn btn-primary"
                      busy={busy}
                    >
                      Create Your Account
                    </ButtonLoadingOnBusy>
                  </div>
                  <div className="flex flex-col pt-4 items-center text-sm">
                    <span>
                      Already have an account?{" "}
                      <Link to={"/auth/login"} className="link link-primary">
                        Log In
                      </Link>
                    </span>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </Form>
  );
};

export default RegistrationPage;
